module.exports = __webpack_public_path__ + "static/media/40.c25ed859.jpg";